import React from "react";

const List = React.memo(({data, renderItem, keys=null}) => {
    if(keys){
        return keys.map((key, index) => renderItem(data[key], key+"-"+index));
    }
    return data.map((item, index) => renderItem(item, item+"-"+index));
})
 
export default List;